<template>
  <auth-layout pageClass="login-page">
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-lg-4 col-md-6 col-sm-8">
        <form @submit.prevent="submit">
          <!-- <fade-render-transition> -->
            <card>
              <l-alert type="danger" v-show="errorMessage">
                <span>
                  <b> </b> {{ errorMessage }}
                </span>
              </l-alert>
              <div slot="header">
                <div class="text-center logo-wrapper">
                  <img :src="'/static/img/' + style + '_logo.png'" class="wamed-logo" >
                </div>
                <h3 class="card-title text-center">Passwort vergessen</h3>
              </div>
              <div>
                <fg-input label="Email Adresse"
                  type="email"
                  v-model="email"
                ></fg-input>
              </div>
              <div class="text-center">
                <button type="submit" class="btn btn-fill btn-primary btn-round btn-wd"
                  :disabled="! canSubmit"
                >
                  Passwort zurücksetzen
                </button>
                <br>
                <div class="forgot">
                  <router-link to="/login" class="card-category">
                    Zur Anmeldung
                  </router-link>
                </div>
              </div>
            </card>
          <!-- </fade-render-transition> -->
        </form>
      </div>
    </div>
  </auth-layout>
</template>
<script>
import LAlert from 'src/components/Alert'

import AuthLayout from './AuthLayout.vue'
export default {
  components: {
    AuthLayout,
    LAlert
  },
  data () {
    return {
      email: '',
      errorMessage: '',
      style:  process.env.VUE_APP_STYLE ? process.env.VUE_APP_STYLE : 'ederit'
    }
  },
  methods: {
    submit () {
      this.errorMessage = ''

      this.$store.dispatch('forgotPassword', { email: this.email }).then(() => {
        this.$notify({
          message: 'Email zum Zurücksetzen des Passworts wurde versandt.',
          type: 'success'
        })
        this.$router.push('/login')
      }).catch(({ response }) => {
        const key = Object.keys(response.data.errors)[0]
        this.errorMessage = response.data.errors[key][0]
      })
    }
  },
  computed: {
    canSubmit () {
      return this.email.trim()
    }
  }
}
</script>
<style>
  .navbar-nav .nav-item p{
    line-height: inherit;
    margin-left: 5px;
  }
</style>
